import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToolbarComponent } from '../../components/toolbar/toolbar.component';

@Component({
  selector: 'app-blank-layout',
  standalone: true,
  imports: [RouterOutlet, ToolbarComponent],
  template: `
    <app-toolbar></app-toolbar>
    <main class="blank-content">
      <router-outlet></router-outlet>
    </main>
  `,
  styles: [
    `
      .blank-content {
        min-height: calc(100vh - 64px);
        padding: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    `,
  ],
})
export class BlankLayoutComponent {}
